import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { FilterHeaderComponent } from '../filter-header/filter-header.component';
import { BaseFilterComponent } from '../filter/base-filter.component';

@Component({
  selector: 'vectronic-last-x-records-filter',
  templateUrl: './last-x-records-filter.component.html',
  styleUrls: ['./last-x-records-filter.component.scss'],
  imports: [
    FilterHeaderComponent,
    MatSelectModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
  ],
})
export class LastXRecordsFilterComponent extends BaseFilterComponent {
  maxValue = 999999;

  getValueFromLastXInput(input) {
    if (parseInt(input.value) < 1) {
      input.value = 1;
      this.filtersForm().get(this.controlName()).setValue(1);
    } else if (parseInt(input.value) > this.maxValue) {
      input.value = this.maxValue;
      this.filtersForm().get(this.controlName()).setValue(this.maxValue);
    } else {
      input.value = parseInt(input.value);
      this.filtersForm().get(this.controlName()).setValue(parseInt(input.value));
    }
  }
}
